import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CloseIcon from './../../../assets/img/icon/close-white.svg';
import Linkedin from '../../../assets/img/logo/linkedin-logo.svg';
import Logo from '../../../assets/img/logo/w-logo.svg';
import Style from './style.module.scss';

const MobileMenu = ({
  isOpen,
  onClose,
  isActiveRoute,
  routes,
  switchLanguage,
  currentLang,
  excludeLinks,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const changeLanguage = (language) => {
    switchLanguage(language, i18n, pathname, navigate);
    onClose();
  };

  return (
    <div className={`${Style.overlay} ${isOpen ? Style.open : ''}`}>
      <div className={Style.header}>
        <div className={Style.menu}>
          <p className={Style.menuTitle}>{t('menu')}</p>
          <div className={Style.lang}>
            <span
              className={clsx({ [Style.active]: currentLang === 'tr' })}
              onClick={() => changeLanguage('tr')}
            >
              TR
            </span>{' '}
            |{' '}
            <span
              className={clsx({ [Style.active]: currentLang === 'en' })}
              onClick={() => changeLanguage('en')}
            >
              EN
            </span>
          </div>
        </div>

        <button onClick={onClose} className={Style.closeBtn}>
          <img src={CloseIcon} alt="close" />
        </button>
      </div>

      <nav className={Style.links}>
        {routes
          .filter((item) => !excludeLinks.includes(item.key))
          .map((item) => {
            const isActive = isActiveRoute(item, pathname);
            return (
              <Link
                key={item.key}
                to={item.route}
                className={clsx({ [Style.activeLink]: isActive })}
                onClick={onClose}
              >
                {item.title}
              </Link>
            );
          })}
      </nav>

      <div className={Style.footer}>
        <div className={Style.brand}>
          <img src={Logo} alt="logo" />
        </div>
        <div className={Style.social}>
          <a
            href="https://www.linkedin.com/company/ngaming/jobs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Linkedin} alt="nGaming-Linkedin-logo" />
          </a>
        </div>
        <div className={Style.legal}>
          {routes
            .filter((item) => excludeLinks.includes(item.key))
            .map((item) => {
              const isActive = isActiveRoute(item, pathname);
              return (
                <Link
                  key={item.key}
                  to={item.route}
                  className={clsx({ [Style.activeLink]: isActive })}
                  onClick={onClose}
                >
                  {item.title}
                </Link>
              );
            })}
        </div>
        <div className={Style.copy}>Copyright © 2026 | NGAMING</div>
      </div>
    </div>
  );
};

export default MobileMenu;
